function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("User information is spread everywhere. WhiteBox combines it.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox links user information from multitude of unrelated data sources. "),_c('strong',[_vm._v("WhiteBox imports user information automatically from almost everywhere:")]),_vm._v(" CRM/ERP systems, cloud services like Google Sheets, Google Calendar, Office 356, offline Excel files and even systems at customer's premises computer. These integrations unlock reporting on the entire path of the digital marketing funnel stages.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox enables access to user-level information in the browser without user login. By using the WhiteBox API, marketers and developers can work together on delivering advanced marketing campaigns on the website and the advertising platforms.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/meetings","interaction":"meetings","title":"(Offline User)|Interactions","image":"/img/interactions/5.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }